<template lang="pug">
.channel-nextProgram.border-left
  channelProgram.flex-grow-1(v-show="nextProgram", :data="nextProgram", :humanize="true", :time="true", background="true")
</template>

<script>
import channelProgram from "./channel-program.vue"
export default {
  name: "channel-next-program",
  components: { channelProgram },
  data() {
    return {
      activeChannel: null
    }
  },
  computed: {
    allEpgs() {
      return this.$store.state.live.epgs[this.activeChannel?.epg_id] || []
    },
    nextProgram() {
      const now = this.$moment().valueOf()
      const res = this.allEpgs.find(item => item.start > now)
      if (res) res.next = true
      return res
    }
  },
  mounted() {
    _$.vue.$on("channel-guide", e => this.updateChannel(e))
  },
  methods: {
    updateChannel(channel) {
      this.activeChannel = channel
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-nextProgram {
  padding-left: 5px;
  display: flex;
  align-items: center;
  height: 100%;

  .channel-program {
    justify-content: center;
    padding-left: 40px;
    height: 108px !important;
  }
}
</style>
